<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/12q2agc/tc-custom/9781626815292.jpg?1703690348385" alt="This image is the cover for the book Shadow Haven"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Shadow Haven
      </h1>
      <p class="bookDescription body article font2">
        <b>The Louisiana bayou heats up when a grieving psychic returns home to find a new chance at love—and a foreboding message from the spirit realm. </b><br/>  <br/> When Boston psychic Gabriella Deveaux’s husband is killed in a plane crash, she and her daughter head home to the Louisiana estate where Gabriella was raised. Shocked to find the gracious old estate is crumbling, Gabriella is even more horrified to learn that she’s lost her connection to the spirit world. Into this chaos comes Jarrod Landry, her new lawyer—but while Gabriella is hesitant to trust the man, she can’t fight the sultry heat of attraction between them. When an otherworldly presence makes itself known, Gabriella must choose between guarding her battered heart, or confronting an evil more malevolent than she has ever known.<br/>  <br/><b>Praise for Jill Jones </b><br/> “Jones is especially adept at creating tense plots and authentic characters.” —<i>Publishers Weekly</i><br/>  <br/> “Spellbinding. Jill Jones continues to carve out a most unique and extraordinary niche for herself with her completely captivating and unusual novels.” —<i>RT Book Reviews</i>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Jill Jones
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Diversion Books
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?1adffe82